import { FC } from 'react';

import type { AvatarProps } from 'antd';
import { Avatar as AvatarAnt } from 'antd';
import cn from 'classnames';

import { useAppConfigRetrieveQuery } from 'shared/api';

import styles from './Avatar.module.scss';

interface IAvatarProps extends AvatarProps {
	isProfile?: boolean;
	name?: string;
	color?: string;
}

export const Avatar: FC<IAvatarProps> = ({ className, isProfile, name, color = 'prime', ...props }) => {
	const { data: appConfig } = useAppConfigRetrieveQuery();
	const shortName = (name || appConfig?.user?.email)?.slice(0, 2)?.toUpperCase();

	const colorStyle = `avatar_${color}`;
	return (
		<AvatarAnt
			className={cn(className, styles.avatar, styles[colorStyle], { [styles.avatar_profile]: isProfile })}
			{...props}>
			{shortName}
		</AvatarAnt>
	);
};
